import React, { createContext, useState, useEffect } from "react";

import { axiosPublic } from "../Utils/axios";

export const ServicesContext = createContext();

const ServicesContextProvider = ({ children }) => {
  
  const [ services, setServices ] = useState({});
  const [servicesArray, setServicesArray] = useState([])

  useEffect(() => {
    const fetchServices = async () => {

      try {

        const response = await axiosPublic.get("getServicesData");

        const data = await response.data.data;

        const formattedServices = {};

        data.forEach((service, i) => {
          
          const { _id, images, code, localContent } = service;

          formattedServices[ `service${code}` ] = { _id, images, code, localContent };
          
        });

        setServices(formattedServices);

        setServicesArray(data)

      } catch (error) {
        console.error(error);
      }
    };

    fetchServices();

  }, []);

  
  
  return (
    <ServicesContext.Provider value={{
      urgentAid: services?.service59,
      businessAid: services?.service61,
      internship: services?.service62,
      startUp:services?.service63,
      childLabour:services?.service66,
      socialServices: services?.service74,
      servicesArray
    }}>
      {children}
    </ServicesContext.Provider>
  );
};

export default ServicesContextProvider